export default __webpack_public_path__ + "./images/mu.44a93739.png";